import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { Icon } from "@vds/icons";
import {
  REMOVE_GROUP_MODAL_TITLE,
  REMOVE_MODAL_MESSAGE_PREFIX,
  REMOVE_GROUP_MODAL_MESSAGE_SUFFIX,
  MODAL_CONFIRM_REMOVE_BUTTON,
  MODAL_CANCEL_BUTTON
} from "../../global/constants/userDetailsConstants";

const RemoveGroupModal = ({ opened, groupToRemove, onConfirm, onClose }) => {
  return (
    <Modal
      key={groupToRemove?.groupId || 'remove-group-modal'}
      opened={opened}
      hideCloseButton={true}
      className="modal-confirmation user-groups-modal"
      disableOutsideClick={true}
      onClose={onClose}
      closeButton={
        <div
          className="modal-close-button"
          data-testid="userdetails_denyRemoveGroupButton"
          onClick={onClose}
        >
          <Icon name="close" ariaHidden={true} />
        </div>
      }
    >
      <Title size="large" bold primitive="h2" viewport="desktop">
        {REMOVE_GROUP_MODAL_TITLE}
      </Title>
      <ModalBody>
        <Body size="medium" viewport="desktop" primitive="span">
          <div>
            <p className="modal-confirmation-text">
              {REMOVE_MODAL_MESSAGE_PREFIX} <strong>{groupToRemove?.userName}</strong> {REMOVE_GROUP_MODAL_MESSAGE_SUFFIX} <strong>{groupToRemove?.groupName}</strong>?
            </p>
            <ModalFooter
              buttonData={{
                primary: {
                  "data-testid": "userdetails_confirmRemoveGroupButton",
                  className: "modal-button-width",
                  children: MODAL_CONFIRM_REMOVE_BUTTON,
                  onClick: onConfirm,
                },
                close: {
                  "data-testid": "userdetails_denyRemoveGroupNoButton",
                  children: MODAL_CANCEL_BUTTON,
                  className: "modal-button-width",
                  onClick: onClose,
                },
              }}
            />
          </div>
        </Body>
      </ModalBody>
    </Modal>
  );
};

export default RemoveGroupModal;
